/*
 *   File : custom-textbox.js
 *   Author : https://evoqins.com
 *   Description : Input component
 *   Integrations : null
 *   Version : 1.0.0
*/
import React, { useRef, useState } from 'react';

import Icon from '../Icon/icon';

import style from '../../Styles/Component/custom-textbox.module.scss';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const CustomForeignInput = React.memo((props) => {
    const [isInputFocused, setInputFocus] = useState(false);
    const phoneInput = useRef();



    const _handleFocus = (e) => {
        e.stopPropagation();
        setInputFocus(true);
    };

    const _handleBlur = (e) => {
        e.stopPropagation();
        setInputFocus(false);
    };



    const _handleNumberChange = (phone, data) => {
        props.handleChange?.(phone, data); // Full phone number with country code
    };

    return (
        <div className={
            props.error && props.error.length !== 0 ?
                `${props.className} ${style.e_input_wrapper} ${style.e_error_input} position-relative w-100` :
                `${props.className} ${style.e_input_wrapper} position-relative w-100`}>
            {/* Input box */}
            {/* Phone number prefix */}

            {/* <input
                value={props.value}
                id={props.id ? props.id : props.label}
                type={props.type ? props.type : 'text'}
                readOnly={props.disabled}
                className={`${style.e_phone_input} ${props.inputClass} color-charleston-green e-poppins-regular e-font-16 w-100 no-outline padding-32px-left`}
                onChange={_handleChange}
                onFocus={_handleFocus}
                onBlur={_handleBlur}
                onWheel={_handleOnWheel}
                onKeyDown={_validateNumber}
                required
                onClick={_handleClick}
            /> */}
            <PhoneInput
                country={'us'}
                enableSearch
                searchPlaceholder="Search country here..."
                placeholder={props.placeholder}
                searchNotFound="No countries found"
                value={props.value}
                excludeCountries={props.excludeCountries}
                onChange={_handleNumberChange}
                inputProps={{
                    ref: phoneInput,
                    placeholder: props.placeholder || "Enter phone number",
                    onFocus: _handleFocus,
                    onBlur: _handleBlur
                }}
                disableCountryGuess={true}
                countryCodeEditable={false}
                // containerClass={`custom-phone-container ${props.error ? "error" : ""}`}
                inputClass={`${style.e_foreign_input} ${props.inputClass} color-charleston-green e-poppins-regular e-font-16 w-100 no-outline `}
                // buttonClass="custom-phone-dropdown"
                disabled={props.disabled}
            />
            {/* label */}
            <label className={`${style.e_foreign_input_label} ${style.e_error_input} position-absolute e-poppins-regular e-font-14 cursor-text p-0`}
                htmlFor={props.id ? props.id : props.label}>
                {props.label}
                <span className='color-red'>
                    {props.postfix}
                </span>
            </label>
            {/* Error text */}
            <p className='color-deep-red e-inter-regular margin-block-end-0 e-font-12 position-absolute mt-1'>
                {props.error &&
                    <Icon icon="info-circle"
                        className="vertical-sub"
                        size={16} />
                }
                {props.error}
            </p>
        </div>
    )
})

CustomForeignInput.defaultProps = {
    value: '',
    handleChange: () => { },
    className: '',
    error: '',
    labelClass: 'bg-body-color'
};

export default CustomForeignInput;